import { useMemo } from 'react';

import { drawerAddConfig } from 'components/MenuManagement/menuManagementColumns';
import {
  ColumnType,
  NewItemDefaults,
} from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';

interface UseAddNewDrawerColumnsProps {
  newItemDefaults: NewItemDefaults;
  isCateringMenu: boolean;
}
interface UseAddNewDrawerColumnsResult {
  newItemColumns: ColumnType[];
}

export function useAddNewDrawerColumns({
  newItemDefaults,
  isCateringMenu,
}: UseAddNewDrawerColumnsProps): UseAddNewDrawerColumnsResult {
  const newItemColumns = useMemo(() => {
    const config = drawerAddConfig as Record<string, ColumnType[]>;
    const columns = config[newItemDefaults.itemType]?.reduce<ColumnType[]>(
      (accumulator, current) => {
        const dataIndex = current?.dataIndex;

        if (dataIndex === 'servingsTag' && !isCateringMenu) {
          return accumulator;
        }

        if (!dataIndex || !['minimum', 'maximum'].includes(dataIndex)) {
          accumulator.push(current);
        } else if (dataIndex === 'minimum') {
          const maxColumn = config[newItemDefaults.itemType]?.find(
            column => column?.dataIndex === 'maximum',
          );
          accumulator.push({
            dataIndex: 'minMax',
            minimum: current,
            maximum: maxColumn,
          });
        }
        return accumulator;
      },
      [],
    );
    return columns;
  }, [newItemDefaults, isCateringMenu]);

  return { newItemColumns };
}
